/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import Slideout from 'components/transition/Slideout';
import SlideoutContent from 'components/slideout/SlideoutContent';
import StringResources from 'nls/StringResources';

import CustomComparison from './CustomComparison';
import ComparisonRecommendations from './ComparisonRecommendations';

import './index.scss';

const CLASS_NAME = 'explore-slideout-compareChooser';

class CompareChooser_Slideout extends Component {

	render() {
		const { active, onClose } = this.props;

		return (
			<Slideout
				active={active}
				className="explore__animation--slideDown"
				fullHeight={true}
				onClickOutside={onClose}
			>
				<SlideoutContent
					title={StringResources.get('compareChooser_title')}
					subTitle={StringResources.get('compareChooser_subTitle')}
					onClose={onClose}
					className={CLASS_NAME}
				>
					<CustomComparison
						recommendationVM={this.props.customRecommendationVM}
						dashboardApi={this.props.dashboardApi}
						logger={this.props.logger}
						onItemSelected={this.props.onItemSelected}
						onItemAdded={this.props.onItemAdded}
					/>
					<ComparisonRecommendations
						recommendationVM={this.props.smartsRecommendationVM}
						dashboardApi={this.props.dashboardApi}
						logger={this.props.logger}
						onItemSelected={this.props.onItemSelected}
						onItemAdded={this.props.onItemAdded}
					/>
				</SlideoutContent>
			</Slideout>
		);
	}
}

CompareChooser_Slideout.propTypes = {
	active: PropTypes.bool,
	onClose: PropTypes.func,
	dashboardApi: PropTypes.object.isRequired,
	logger: PropTypes.object.isRequired,
	customRecommendationVM: PropTypes.object.isRequired,
	smartsRecommendationVM: PropTypes.object.isRequired,
	selectedWidgetModel: PropTypes.object.isRequired,
	onItemSelected: PropTypes.func.isRequired,
	onItemAdded: PropTypes.func
};

CompareChooser_Slideout.defaultProps = {
	active: false,
	onClose: () => {}
};

export default CompareChooser_Slideout;



// WEBPACK FOOTER //
// ./src/js/components/compareChooser/index.js